import { render, staticRenderFns } from "./RootSettings.vue?vue&type=template&id=324d7ad4&"
import script from "./RootSettings.vue?vue&type=script&lang=ts&"
export * from "./RootSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports